import React from 'react';
import { message, Modal, Button, Icon, Input, Table, Spin } from 'antd';
const webConfig = require ('../config.json');


/**
 * @title 	abstractReduxClass				以Redux管理数据的抽象基类
 * @method 	publicCreate 							添加数据
 * @method 	publicUpdate 							修改数据
 * @method 	publicSubmit 							添加/修改标准格式数据
 * @method 	publicDelete 							批量删除数据
 * @method 	publicAppend 							无刷新提交数据
 * @method 	publicExport 							过滤条件导出数据
 * @method 	publicImport 							导入数据
 * @method 	publicDownloadTemplate		下载导入模版
 * @method 	publicHandle 							自定义处理数据
 * @method 	setPageFilter 						分页过滤表格数据
 * @method 	publicImportView 					创建导入弹出层视图
 * @method 	publicTableView 					创建动态表格视图
 */
export default class ReduxComponent extends React.Component {

	constructor(props) {
		super(props);
		if (ReduxComponent === this.constructor) {
			throw new TypeError("Error! ReduxComponent should be considered as an abstract class");
		}
	}

	handleError = message => console.error(message)

	toggleCurrentModal = status => {
		let currentStatus = {
			currentModalStatus: null === status ? !this.state.currentModalStatus : status
		}
		this.setState(currentStatus);
	}

	componentWillMount() {
		if (!this.deleteRowSelection) {
			this.rowSelection = {
				onChange: (selectedRowKeys, selectedRows) => {
					let ids = selectedRows.map(row => row.id);
					this.setState({selectedIDs: ids});
				}
			}
		}
		if (this.props[this.moduleName] && this.props[this.moduleName][this.childModuleName]) {
			if ("loaded" !== this.props[this.moduleName][this.childModuleName].dataStatus || this.initReload) {
				if ('function' === typeof this.actions.changeAction) {
					this.actions.changeAction({}, "loading");
				}else{
					this.handleError('undefined change action');
				}
			}			
		}else{
			this.handleError('module name or child module name not set');
		}
		if ("function" === typeof this.customComponentWillMount) {
			this.customComponentWillMount();
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps[this.moduleName][this.childModuleName].loadCounter !== this.props[this.moduleName][this.childModuleName].loadCounter) {
			if ("function" === typeof this.actions.selectAction) {
				let gets = {};
				Object.keys(nextProps[this.moduleName][this.childModuleName].filters).forEach(key => {
					// console.log(nextProps[this.moduleName][this.childModuleName].filters[key])
					if (nextProps[this.moduleName][this.childModuleName].filters[key]) {
						gets[key] = nextProps[this.moduleName][this.childModuleName].filters[key];
					}
				})
				this.actions.selectAction(gets);
			}else{
				this.this.handleError("undefined select action");
			}
		}
		if ("function" === typeof this.customComponentWillReceiveProps) {
			this.customComponentWillReceiveProps(nextProps);
		}
	}

	publicCreate = posts => {
		if ("function" === typeof this.actions.createAction) {
			this.actions.createAction(posts, res => {
				if (res.data.Success) {
					this.toggleCurrentModal(false);
					message.success("添加数据成功", 4);
					if ("function" === typeof this.actions.changeAction) {
						this.actions.changeAction();
					}else{
						this.handleError('undefined change action');
					}
				}else{
					message.error("添加数据失败 " + res.data.Errors[0], 4);
				}
			});
		}else{
			this.handleError("undefined create action");
		}
	}

	publicAppend = posts => {
		if ("function" === typeof this.actions.appendAction) {
			this.actions.appendAction(posts, res => {
				if (res.data.Success) {
					this.toggleCurrentModal(false);
					message.success("添加数据成功", 4);
				}else{
					message.error("添加数据失败 " + res.data.Errors[0], 4);
				}
			});
		}else{
			this.handleError('undefined append action');			
		}
	}

	publicUpdate = puts => {
		if ("function" === typeof this.actions.updateAction) {
			this.actions.updateAction(puts, this.state.currentIndex, res => {
				if (res.data.Success) {
					this.toggleCurrentModal(false);
					message.success("修改数据成功", 4);
					this.actions.changeAction();
				}else{
					message.error("修改数据失败 " + res.data.Errors[0], 4);
				}
			});
		}else{
			this.handleError('undefined update action');
		}
	}

	publicSubmit = () => {
		this.props.form.validateFields((err, values) => {
			if (!err) {
				let currentData = {
					...this.state.currentData,
					...values
				}
				let callee = null === this.state.currentIndex ? this.publicCreate : this.publicUpdate;
				callee(currentData);
			}
		})
	}

	publicDelete = () => {
		if (!this.state.selectedIDs || 0 === this.state.selectedIDs.length) {
			message.error('请选择要删除的内容', 4);
			return false;
		}
		Modal.confirm({
			title: '确定删除选中的内容么?',
			okText: '确认',
			cancelText: '取消',
			onOk: () => {
				if ("function" === typeof this.actions.deleteAction) {
					this.actions.deleteAction({ids: this.state.selectedIDs}, res => {
						if (res.data.Success) {
							this.setState({selectedIDs: []});
							message.success('删除操作成功', 4);
							if ("function" === typeof this.actions.changeAction) {
								this.actions.changeAction();
							}else{
								this.handleError("undefined change action");
							}
						}else{
							message.error('删除操作失败' + res.data.Errors[0], 4);
						}
					});
				}else{
					this.handleError('undefined delete action');
				}
			},
			onCancel: () => {}
		});
	}

	publicExport = () => {
		let gets = {};
		Object.keys(this.props[this.moduleName][this.childModuleName].filters).forEach(key => {
			if (this.props[this.moduleName][this.childModuleName].filters[key]) {
				gets[key] = this.props[this.moduleName][this.childModuleName].filters[key];
			}
		})
		delete gets.page;
		let ref = Modal.info({
			content: "正在准备需要下载的文件, 下载文件可能被浏览器阻挡, 请注意！"
		});
		if ("function" === typeof this.actions.exportAction) {
			this.actions.exportAction(gets, res => {
				ref.destroy();
				if (res.data.Success) {
					window.open(res.data.Message);
				}else{
					message.error('导出数据失败, ' + res.data.Errors[0], 4);
				}
			}, err => message.error('导出数据失败', 4))
		}else{
			this.handleError("undefined export action");
		}
	}


	publicHandle = config => {
		if (config.alert) {
			Modal.confirm({
				title: '确定' + config.title + "么?",
				okText: '确认',
				cancelText: '取消',
				onOk: () => this.publicHandleAction(config),
				onCancel: () => {}
			});
		}else{
			this.publicHandleAction(config);
		}
	}

	publicHandleAction = config => {
		if ("function" === typeof config.callee) {
			config.callee(config.data, res => {
				if (res.data.Success) {
					if(config.alert){
						message.success(config.title + "成功", 4);
					}
					if ("function" === typeof config.callback) {
						config.callback(res);
					}
				}else{
					message.error(config.title + "失败, " + res.data.Errors[0], 4);
				}
			}, err => message.error(config.title + "失败, ", 4))
		}
	}

	publicImportView = () => (
		<Modal width="800px"
			visible={this.state.importModalStatus}
			title="文件导入"
			destroyOnClose={true}
			onCancel={() => this.setState({importModalStatus: false})}
			footer={<Button type="back" 
				onClick={() => this.setState({importModalStatus: false})}>关闭</Button>}>
			<div style={{textAlign:"center",margin:"20px 0px 20px"}}>
				<div>
					<Button type="primary" onClick={this.publicDownloadTemplate.bind(this, {})}>
						<Icon type="cloud-download-o" />
						<span>下载模板</span>
					</Button>
				</div>
				<div style={{marginTop:"40px"}}>
					<div>导入文件</div>
					<Input type="file" style={{height:"38px"}} onChange={this.setUploadedFile} />
					<Button type="primary" style={{marginTop:"20px"}} onClick={this.publicImport}>
						<Icon type="cloud-upload-o" />
						<span>开始导入</span>
					</Button>
				</div>
			</div>
		</Modal>
	)

	setUploadedFile = event => this.setState({uploadedFile: event.target.files[0]})

	publicDownloadTemplate = gets => {
		let ref = Modal.info({
			content: "正在准备需要下载的文件, 下载文件可能被浏览器阻挡, 请注意！"
		});
		if ("function" === typeof this.actions.downloadTemplateAction) {
			this.actions.downloadTemplateAction(gets, res => {
				ref.destroy();
				if (res.data.Success) {
					window.open(res.data.Message);
				}else{
					message.error('下载模版失败, ' + res.data.Errors[0], 4);
				}
			}, err => message.error('下载模版失败', 4));
		}else{
			this.handleError("undefined downloadTemplate action");
		}
	}

	publicImport = () => {
		if (!this.state.uploadedFile) {
			message.error("请选择需要导入的文件", 4);
			return;
		}
		if ("function" === typeof this.actions.importAction) {
			let ref = Modal.info({
				content: "正在导入文件, 请稍后..."
			});
			let formData = new FormData();
			formData.append("uploadedFile", this.state.uploadedFile);
			this.actions.importAction(formData, res => {
				ref.destroy();
				if(res.data.Success) {
					message.success('导入文件成功, ' + res.data.Message, 4);
					this.setState({importModalStatus: false});
					this.actions.changeAction({}, "loading");
					if(res.data.Object){
						window.open(res.data.Object);
					}
				}else{
					message.error("导入文件失败, " + res.data.Errors[0], 4)
				}
			},err => message.error("导入文件失败", 4));
		}else{
			this.handleError("undefined import action");
		}
	}

	setPageFilter = pagination => this.actions.changeAction({
		page: pagination.current
	}, "reload")

	publicTableView = () => {
		switch (this.props[this.moduleName][this.childModuleName].dataStatus) {
			case "reload":
			case "loaded":
				return (
					<Table columns={this.column}
					dataSource={this.props[this.moduleName][this.childModuleName].data.Data}
					rowKey={record => record.id}
					scroll={{x: 800}}
					rowSelection={this.rowSelection}
					pagination={{
						total: this.props[this.moduleName][this.childModuleName].data.Total,
						pageSize: this.props[this.moduleName][this.childModuleName].data.PageSize,
						current: this.props[this.moduleName][this.childModuleName].filters.page}}
					onChange={this.setPageFilter} />)
			case "error":
				return (
					<div style={{textAlign:'center', margin: '100px 0px'}}>
						{webConfig.httpFetchErrorInformation}
					</div>);
			case "loading":
			case "unload":
				return (
					<div style={{textAlign:'center', margin: '100px 0px'}}>
						<Spin size="large" />
					</div>);
			default :
				return null;
		}
	}
}



// WEBPACK FOOTER //
// ./src/routes/ReduxComponent.js